import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  ApiResourceLocation,
  Dictionary,
  ReadonlyHttpApiListRepository,
  Result,
} from '@softline/core';
import {
  SOFTLINE_API_LIEFERANTENSTAMM_DOCUMENT,
  SOFTLINE_API_LIEFERANTENSTAMM_UPDATE_DOCUMENT,
} from '../lieferantenstamm.api';
import { Document } from '../types/document';

export interface LieferantenDokumenteQuery {
  idktostamm: number | undefined;
}

@Injectable()
export class LieferantenDokumenteRepository extends ReadonlyHttpApiListRepository<
  Result<Document[]>,
  LieferantenDokumenteQuery
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_LIEFERANTENSTAMM_DOCUMENT);
  }

  override getLoadQueryParams(params: LieferantenDokumenteQuery): Dictionary<unknown> {
    return { idktostamm: params.idktostamm };
  }

  async updateDoc(doc: Document, name: string) {
    const location = {
      path: SOFTLINE_API_LIEFERANTENSTAMM_UPDATE_DOCUMENT,
      pathParams: {
        documentKey: doc.dokument.documentKey,
      },
    } as ApiResourceLocation;
    return await this.dataAccess.patch(location, {
      name,
    });
  }

  async deleteFile(doc: Document) {
    const location = {
      path: SOFTLINE_API_LIEFERANTENSTAMM_UPDATE_DOCUMENT,
      pathParams: {
        documentKey: doc.dokument.documentKey,
      },
    } as ApiResourceLocation;
    await this.dataAccess.delete(location);
  }
}
